import React from 'react';
import { withTranslation } from 'react-i18next';
import Btn from 'components/Btn';
import * as UIcons from '@iconscout/react-unicons';
import { useDispatch } from 'react-redux';
import { showModal } from 'store/slices/miscSlice';
import ChangePasswordForm from './components/ChangePasswordForm';
import { AccountSettingsValidation } from 'pages/Settings/validation';

export default withTranslation()(function AccountSettings({t}) {
  const dispatch = useDispatch();

  return (
    <section className="bg-white w-full p-8 rounded-xl mb-10">
      <h2 className="text-2xl text-secondary p-4">{ t('settings.account_settings.settings') }</h2>

      <div className="grid md:grid-cols-2 gap-3">
        <label className="border p-3.5 rounded-xl w-full relative">
          ************************

          <UIcons.UilEye className="text-placeholder absolute top-3.5 right-2" />
        </label>

        <div className="w-full md:w-36 h-12 overflow-hidden rounded-xl">
          <Btn 
            text={t('settings.account_settings.change_pwd')}
            textColor="text-white"
            bg="#1976D2"
            classList="w-full md:w-36 h-12"
            click={() => dispatch(showModal({
              title: t('settings.account_settings.change_pwd'),
              method: 'post',
              content: ChangePasswordForm,
              validation: AccountSettingsValidation,
              url: 'auth/change-password',
              successMsg: 'Password reset successful',
              formClass: 'w-11/12 md:w-[390px]'
            })) }
          />
        </div>
      </div>
    </section>
  )
})
